// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./web_components"

// This is to prevent the number input from being scrolled when the user scrolls the page
document.addEventListener("wheel", () => {
  if (document.activeElement?.type === "number") document.activeElement.blur()
}, { passive: true })
import { StreamActions } from "@hotwired/turbo"

StreamActions.refresh = function() {
  console.log("refresh")
  setTimeout(() => {
    window.Turbo.visit(window.location.href, { action: "morph" })
  }, 100)
}